// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/requestcatalog/v1/requestcatalogbundles.proto" (package "c1.api.requestcatalog.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { TaskView } from "../../task/v1/task";
import { Duration } from "../../../../google/protobuf/duration";
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestBundleRequest
 */
export interface RequestBundleRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
    /**
     * @generated from protobuf field: string requested_for_id = 2
     */
    requestedForId: string;
    /**
     * @generated from protobuf field: string request_reason = 3
     */
    requestReason: string;
    /**
     * @generated from protobuf field: google.protobuf.Duration grant_duration = 5
     */
    grantDuration?: Duration;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestBundleResponse
 */
export interface RequestBundleResponse {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskView task = 1
     */
    task?: TaskView;
}
// @generated message type with reflection information, may provide speed optimized methods
class RequestBundleRequest$Type extends MessageType<RequestBundleRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestBundleRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "requested_for_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "request_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "grant_duration", kind: "message", T: () => Duration, options: { "validate.rules": { duration: { gt: {} } } } }
        ]);
    }
    create(value?: PartialMessage<RequestBundleRequest>): RequestBundleRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.requestedForId = "";
        message.requestReason = "";
        if (value !== undefined)
            reflectionMergePartial<RequestBundleRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestBundleRequest): RequestBundleRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                case /* string requested_for_id */ 2:
                    message.requestedForId = reader.string();
                    break;
                case /* string request_reason */ 3:
                    message.requestReason = reader.string();
                    break;
                case /* google.protobuf.Duration grant_duration */ 5:
                    message.grantDuration = Duration.internalBinaryRead(reader, reader.uint32(), options, message.grantDuration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestBundleRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        /* string requested_for_id = 2; */
        if (message.requestedForId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.requestedForId);
        /* string request_reason = 3; */
        if (message.requestReason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.requestReason);
        /* google.protobuf.Duration grant_duration = 5; */
        if (message.grantDuration)
            Duration.internalBinaryWrite(message.grantDuration, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestBundleRequest
 */
export const RequestBundleRequest = new RequestBundleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestBundleResponse$Type extends MessageType<RequestBundleResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestBundleResponse", [
            { no: 1, name: "task", kind: "message", T: () => TaskView }
        ]);
    }
    create(value?: PartialMessage<RequestBundleResponse>): RequestBundleResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestBundleResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestBundleResponse): RequestBundleResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.TaskView task */ 1:
                    message.task = TaskView.internalBinaryRead(reader, reader.uint32(), options, message.task);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestBundleResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.TaskView task = 1; */
        if (message.task)
            TaskView.internalBinaryWrite(message.task, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestBundleResponse
 */
export const RequestBundleResponse = new RequestBundleResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.requestcatalog.v1.RequestCatalogBundlesService
 */
export const RequestCatalogBundlesService = new ServiceType("c1.api.requestcatalog.v1.RequestCatalogBundlesService", [
    { name: "RequestBundle", options: { "authz.method": { role: "VIEWER" } }, I: RequestBundleRequest, O: RequestBundleResponse }
]);
